import React, { useContext } from "react"
import { MdLock } from "react-icons/md"
import { Link } from "react-router-dom"
import {
  BsFileText,
  BsCameraVideo,
  BsDownload,
  BsFileBarGraph,
} from "react-icons/bs"
import AppContext from "../../../shared/AppContext"

const Card = (props) => {
  const { series, setIsUpsellModalOpen, setSelectedBundleTitle, hasAccess } =
    props
  const {
    name,
    description,
    mp4File,
    reportFile,
    dataFile,
    pdfFile,
    pdfFiles,
    interactiveReportFile,
  } = series

  const { trackEvent } = useContext(AppContext)

  const onDownloadClick = (series) => {
    trackEvent("Downloaded AI Product Series", {
      series: series.name,
      seriesId: series.id,
      file: props.match.params.slug,
    })
  }

  const openUpsellModal = (linkClicked) => {
    setIsUpsellModalOpen(true)
    setSelectedBundleTitle(name)

    trackEvent("AI Product Series upsell modal", {
      path: location.pathname,
      click_event: "show",
      series: name,
      file_clicked: linkClicked,
    })
  }

  const FileLink = (props) => {
    const { isUserAuthorized, fileType, file, icon } = props

    if (!isUserAuthorized) {
      return (
        <Link
          data-cy="card-modal-link"
          className="ai-product-series-bundle-item"
          onClick={() => {
            openUpsellModal(`AI Product Series: ${file.name}`)
          }}
          to="#"
        >
          {icon}
          <p>{fileType !== "xls" ? file.name : "Results Spreadsheet"}</p>
        </Link>
      )
    }

    if (fileType === "xls") {
      return (
        <a
          data-cy="card-link"
          className="ai-product-series-bundle-item"
          onClick={onDownloadClick(series)}
          href={`/series/${series.slug}/${file.slug}?mode=download&type=${fileType}`}
          download
        >
          {icon}
          <p>Results Spreadsheet</p>
        </a>
      )
    }

    const viewFileUrl = `/ai-product-series/${series.slug}/${file.slug}?type=${fileType}`

    return (
      <Link
        data-cy="card-link"
        className="ai-product-series-bundle-item"
        to={viewFileUrl}
      >
        {icon}
        <p>{file.name}</p>
      </Link>
    )
  }

  return (
    <div className="ai-product-series-bundle-card" data-cy="series-card">
      <div className="badge-container" data-cy="access-badge">
        {!hasAccess && (
          <div className="locked-flag">
            <MdLock className="icon" />
            <span>Locked</span>
          </div>
        )}
      </div>

      <div className="card">
        <div className="thumbnail-image">
          <img
            src={"/static/images/ai.png"}
            alt={"AI Product Series thumbnail"}
          />
        </div>
        <div>
          <div className="title">{name}</div>
          <p>{description}</p>

          <ul className="ai-product-series-main-links">
            {mp4File.fileName ? (
              <FileLink
                fileType="mp4"
                icon={<BsCameraVideo />}
                file={mp4File}
                isUserAuthorized={hasAccess}
              />
            ) : null}
            {reportFile ? (
              <FileLink
                fileType="pdf"
                icon={<BsFileText />}
                file={reportFile}
                isUserAuthorized={hasAccess}
              />
            ) : null}
            {dataFile ? (
              <FileLink
                fileType="xls"
                icon={<BsDownload />}
                file={dataFile}
                isUserAuthorized={hasAccess}
              />
            ) : null}
            {interactiveReportFile ? (
              <FileLink
                fileType="html"
                icon={<BsFileBarGraph />}
                file={interactiveReportFile}
                isUserAuthorized={hasAccess}
              />
            ) : null}
            {pdfFile ? (
              <FileLink
                fileType="pdf"
                icon={<BsFileText />}
                file={pdfFile}
                isUserAuthorized={hasAccess}
              />
            ) : null}
          </ul>

          <ul className="ai-product-series-pdf-links">
            {pdfFiles.map((pdfFile, idx) => {
              return (
                <li key={idx}>
                  <FileLink
                    fileType="pdf"
                    icon={<BsFileText />}
                    file={pdfFile}
                    isUserAuthorized={hasAccess}
                  />
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Card
